import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { BE_URL_2, httpGet } from '../../http';
import { Link } from 'react-router-dom';
import './NotasContables.css';
import { Spinner } from 'react-bootstrap';
import { formatDateMin, formatNumber } from '../../misc/index';


const Egresos = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    useEffect(() => {

        console.log(JSON.parse(sessionStorage.getItem('estado')));

        let newEstado = JSON.parse(sessionStorage.getItem('estado'));
        newEstado.proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        console.log(newEstado);
        
        setEstado(newEstado);
        getNotas(newEstado.proveedor.nit);

    }, []);

    const getNotas = (tercero) => {
        setNotas({
            ...notas,
            loading: true
        });
        const companyId = sessionStorage.getItem('companyId');
        //httpGet('/ProveedoresWS/api/Egresos?emp=' + companyId + '&fechaDesde=20200101&fechaHasta=20301231&tercero=' + tercero).then(
        httpGet(BE_URL_2 + '/api/v1/egresos/notas-contables/tercero/' + tercero + "?empresa=" + companyId + "&pagina=0&cant=1000").then(
            resp => {
                setNotas({
                    ...notas,
                    data: resp.data,
                    loading: false
                });
            }
        ).catch(
            error => {
                console.log(error);
                setNotas({
                    ...notas,
                    loading: false
                });
            }
        );
    }

    const [notas, setNotas ] = useState(
        {
            data: [],
            loading: true,
            error: {}
        }
    );

    const generarEgresoDetallePdf = async (e, egreso2) => {
        e.preventDefault();

        console.log(egreso2);
        const companyId = sessionStorage.getItem('companyId');
        const encabezado = await httpGet('/ProveedoresWS/api/Egresos/encabezado?emp=' + companyId + '&co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);
        const retenciones = await httpGet('/ProveedoresWS/api/Egresos/retenciones?emp=' + companyId + '&co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);
        const detalles = await httpGet('/ProveedoresWS/api/Egresos/detalle?emp=' + companyId + '&co=' + egreso2.co + '&tipoDocumento=' + egreso2.tipoDoc + '&numeroDocumento=' + egreso2.numeroDoc);

        if((encabezado !== null) && (encabezado !== undefined)){
            let egreso = {
                empresa: estado.empresa,
                proveedor: estado.proveedor,
                encabezado: encabezado.data,
                retenciones: retenciones.data,
                detalles: detalles.data
            }

            console.log(egreso);

            props.history.push({ pathname: '/portal/egreso-pdf', state: { egreso: egreso } });
        }
        
    }

    return(
        <div className='page-container'>
            <Title>Comprobantes de egreso</Title>
            {notas.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
            :
                <div className='page-body'>
                    <table className='info-table'>
                        <thead>
                            <tr>
                                <th>DOCUMENTO</th>
                                <th>FECHA DEL DOCUMENTO</th>
                                <th>DETALLE</th>
                                <th>DEBITOS</th>
                                <th>CREDITOS</th>
                                <th>VER</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                notas.data.map(
                                    nota => {
                                        return(
                                            <tr key={nota.id}>
                                                <td>{ nota.tipoDoc + '-' + nota.numeroDoc }</td>
                                                <td>{ formatDateMin(new Date(nota.fechaDoc)) }</td>
                                                <td>{ nota.notas }</td>
                                                <td>${ formatNumber(nota.total_db) }</td>
                                                <td>${ formatNumber(nota.total_cr) }</td>
                                                <td><div className='view-icon-container'><Link to={{ pathname: "/portal/nota-contable-detalle", state: { nota: nota } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link></div></td>
                                                {/*<td><div className='pdf-icon-container' ><Link style={{ color: 'red' }} onClick={(e) => { generarEgresoDetallePdf(e, egreso) }}><FontAwesomeIcon className='view-icon' icon={faFilePdf} /></Link></div></td>*/}
                                            </tr>
                                        );
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default Egresos
